
import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  DataGrid,
  Grid,
  IconButton,
  Stack,
} from 'src/components';
import { useDeleteMesajMutation, useGetMesajQuery, useLazyGetMesajByIdQuery } from 'src/services/Genel/GnlMesajApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import RecordInfo from 'src/parts/Genel/record.info';
import DuyuruTanimSlice from '../DuyuruSlice/DuyuruSlice';
import { GnlMesajRequest } from 'src/models/Genel/GnlMesajRequest';
import IptalNedenSecim from 'src/parts/Diger/IptalNedenSecim';
import { ParametreGrupEnum } from 'src/type/Base/ParametreGrupEnum';
import { useTranslation } from 'react-i18next';
import DuyuruDetay from '../DuyuruDetay';
import DuyuruOkumaDetay from '../DuyuruOkumaDetay';
import { DuyuruIslemEnum, isIptal } from '../DuyuruFunctions';
import { GnlMesajOkumaApi } from 'src/services/Genel/GnlMesajOkumaApi';
import DokumanYukle from 'src/parts/Dokuman/DokumanYukle';
import DokumanEkranTipleri from 'src/parts/Dokuman/DokumanEnum';
import GnlMesajDTO from 'src/models/Genel/GnlMesajDTO';
import BaseComponent from 'src/core/base.component';
import { DuyuruProps } from '../GenelDuyurular';
import ModulEnum from 'src/type/Base/ModulEnum';

const DuyuruKullanimKilavuzu = (props: DuyuruProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const rl = "pages|duyuru|aydinlatmaMetinleri|"

  const [oku, setOku] = useState<boolean>(false);
  const [mesajOku, setMesajOku] = useState<boolean>(false);

  const [iptalActiveRow, setIptalActiveRow] = useState(new GnlMesajDTO());
  const [iptalNedenOpen, setIptalNedenOpen] = useState(false);
  const [iptalDahil, setIptalDahil] = useState(false);
  const [dokumanOpen, setDokumanOpen] = useState<boolean>(false);

  const userLogin = useAppSelector((s) => s.userLogin);
  const loginOrganizasyon = useAppSelector(s => s.userOrganizasyon).data
  const [deleteGnlMesaj, { isLoading: isLoadingDelete }] = useDeleteMesajMutation();

  const [activeRowId, setActiveRowId] = useState(-1);

  const [getMesajById, { isFetching: isFetchingGet }] = useLazyGetMesajByIdQuery();

  const { data: gnlMesajData, isLoading, isFetching } = useGetMesajQuery({
    ...new GnlMesajRequest(),
    loginOrgTreeKey: props.orgTree ? props.orgTree : loginOrganizasyon.treeKey,
    messageType: 5520927870,
    iptalDahil: iptalDahil
  });

  const [getOkumaBilgisi, {
    isFetching: isFetchingOkumaBilgi
  }] = GnlMesajOkumaApi.endpoints.gnlMesajOkumaByFkKullaniciMesajGetir.useLazyQuery();

  const deleteOnClick = (row) => {
    setIptalActiveRow(row);
    setIptalNedenOpen(true);
  };

  const detailAndEditIslemler = async (mesajId: number, tip: DuyuruIslemEnum) => {
    await getMesajById(mesajId)
      .unwrap()
      .then((response) => {
        if (response !== null) {
          dispatch(DuyuruTanimSlice.actions.setDuyuruActiveRow(response));
        } else {
          dispatch(DuyuruTanimSlice.actions.setDuyuruActiveRow(new GnlMesajDTO()));
        }

        if (tip === DuyuruIslemEnum.Edit) {
          dispatch(DuyuruTanimSlice.actions.setAddEditOpen(true));
          dispatch(DuyuruTanimSlice.actions.setMessageType(5520927870));
        } else if (tip === DuyuruIslemEnum.Detail) {
          setOku(true);
        }
      })
      .catch(() => { })
  }

  const readDetailOnClick = async (row: GnlMesajDTO) => {
    await getOkumaBilgisi({
      ...new GnlMesajRequest(),
      pkKullanici: userLogin.userInfo.kullaniciId,
      pkMesaj: row.id
    }).then((res) => {
      dispatch(DuyuruTanimSlice.actions.setMesajOkumaBilgisiDetay(res.data));
      setMesajOku(true);
    })
  };

  return (
    <BaseComponent>
      {oku && (
        <DuyuruDetay loginControl={props.loginControl} setOku={setOku} />
      )}

      {mesajOku && <DuyuruOkumaDetay setMesajOku={setMesajOku} />}

      {!oku && (
        <DataGrid
          pinnedColumns={{ right: ['actions1'] }}
          loading={isLoading || isFetching || isFetchingGet || isLoadingDelete || isFetchingOkumaBilgi}
          addButton={
            props.loginControl
              ? <></>
              : <Button
                authCode="KULLANIMKILAVUZADD"
                modul={ModulEnum.GenelAyarlarGuvenlik}
                customType="add"
                onClick={(e) => {
                  dispatch(DuyuruTanimSlice.actions.setDuyuruActiveRow(new GnlMesajDTO()));
                  dispatch(DuyuruTanimSlice.actions.setAddEditOpen(true));
                  dispatch(DuyuruTanimSlice.actions.setMessageType(5520927870));
                  dispatch(DuyuruTanimSlice.actions.setAddEditBaslik(t(rl + 'kullanimKilavuzu', 'Kullanım Kılavuzu Ekle')));
                }}
              >
              </Button>
          }
          addHeaderColumn={
            <Grid item md={4} xs={12} sx={{ justifyContent: 'center', display: 'grid' }}>
              <Checkbox
                defaultChecked={iptalDahil}
                value={iptalDahil}
                onChange={(e, c) => {
                  setIptalDahil(c);
                }}
                label={t(rl + 'iptalGosterme', 'İptal Edileni Gösterme')}
              />
            </Grid>
          }
          sx={{ height: props.height ? props.height : '800px' }}
          paginationMode="client"
          filterMode="client"
          sortingMode="client"
          initialState={{
            columns: {
              columnVisibilityModel: {
                id: false
              }
            }
          }}
          columns={[
            {
              field: 'id',
              headerName: t(rl + 'iptalGosterme', 'No'),
              width: 120,
              type: "number",
              noThousandSeparator: true,
            },
            {
              field: 'konu',
              headerName: t(rl + 'baslik', 'Başlık'),
              flex: 1
            },
            {
              field: 'gonderimtarihi',
              headerName: t(rl + 'gonderimtarih', 'Yayınlanma Tarihi'),
              type: 'date',
              align: 'center',
              width: 140
            },
            {
              field: 'gecerliliksontarih',
              headerName: t(rl + 'sonlanmaTarih', 'Sonlanma Tarihi'),
              type: 'date',
              align: 'center',
              width: 140
            },
            {
              field: 'iptalBool',
              headerName: t(rl + 'iptalBool', 'İptal'),
              type: 'boolean',
              width: 75
            },
            {
              field: 'actions1',
              headerName: t(rl + 'islemler', 'İşlemler'),
              width: props.loginControl ? 70 : 300,
              resizable: false,
              sortable: false,
              disableColumnMenu: true,
              renderCell: (params) => {
                return (
                  <>
                    <Stack direction="row" spacing={2}>
                      {!props.loginControl && (
                        <>
                          <IconButton
                            authCode="KULLANIMKILAVUZEDIT"
                            modul={ModulEnum.GenelAyarlarGuvenlik}
                            customType="edit"
                            disabled={isIptal(params.row.iptal)}
                            onClick={() => detailAndEditIslemler(params.row.id, DuyuruIslemEnum.Edit)}
                          />
                          <IconButton
                            authCode="KULLANIMKILAVUZDEL"
                            modul={ModulEnum.GenelAyarlarGuvenlik}
                            customType="delete"
                            disabled={isIptal(params.row.iptal)}
                            onClick={() => deleteOnClick(params.row)}
                          />
                        </>
                      )}
                      <IconButton
                        authCode="KULLANIMKILAVUZVIEW"
                        modul={ModulEnum.GenelAyarlarGuvenlik}
                        customType="detail"
                        disabled={isIptal(params.row.iptal)}
                        onClick={() => detailAndEditIslemler(params.row.id, DuyuruIslemEnum.Detail)} />

                      {!props.loginControl && (
                        <>
                          <IconButton customType="mailRead"
                            disabled={isIptal(params.row.iptal)}
                            onClick={() => readDetailOnClick(params.row)} />

                          <IconButton
                            authCode="KULLANIMKILAVUZDOC"
                            modul={ModulEnum.GenelAyarlarGuvenlik}
                            customType='document'
                            onClick={(e) => {
                              setDokumanOpen(true)
                              setActiveRowId(params.row.id);
                            }} />
                        </>
                      )}
                      {!props.loginControl && (
                        <>
                          <RecordInfo
                            id={params.row.id}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            eklemeTarihi={params.row.eklemeTarihi}
                            // iptalKullanici={params.row.fkIptalkullanici}
                            iptalTarihi={params.row.iptaltarih}
                            iptalNedenId={params.row.iptalnedenId}
                            guncellemeTarihi={null}
                            guncelleyenKullanici={null}
                          />
                        </>
                      )}
                    </Stack>
                  </>
                );
              }
            }
          ]}
          getRowId={(r) => r.id}
          rows={gnlMesajData || []}
        />
      )}

      {iptalNedenOpen &&
        <IptalNedenSecim
          parametreGrupEnum={ParametreGrupEnum.TanimlarIptalNedenleri}
          open={iptalNedenOpen}
          onSelected={async (i, a) => {
            await deleteGnlMesaj({
              ...iptalActiveRow,
              iptalnedenId: i
            })
              .then((payload) => {
              })

          }}
          onClosed={() => {
            setIptalNedenOpen(false);
          }}
          title={t(rl + 'kullanimKilavuz', 'Kullanım Kılavuzu ')}
        />
      }

      {dokumanOpen &&
        <DokumanYukle
          dialogMode={true}
          open={dokumanOpen}
          onClose={() => { setDokumanOpen(false); }}
          fullWidth={true}
          maxWidth="md"
          height={600}
          tip={DokumanEkranTipleri.duyuru}
          alanId={activeRowId} />
      }

    </BaseComponent>
  );
};

export default DuyuruKullanimKilavuzu;
